<div class="dialog-header">
  <div class="header-title"><span style="font-size: 120%;">{{dialogHeader}}</span></div>


  <div class="buttons-block" *ngIf="showSourceButton">
    <button class="header-button send-button" mat-button (click)="openImageInNewTab()">
      <span>Open Source</span>
    </button>
  </div>

  <button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="carousel-middle-content">
  <div class="gallery-block">
    <gallery #galleryAngular [items]="images" [thumb]="false" [loop]="false" [gestures]="true"
             (indexChange)="indexChange($event)"></gallery>
  </div>
</div>
